export default "__VITE_ASSET__ExLIJAMz__"